import { callFxgApi } from 'axp-fx-common';

export async function callApiV2(apiUrl, methodType, requestData) {
  const { response, hasErrors } = await callFxgApi(apiUrl, methodType, requestData);
  return { data: response?.data, error: hasErrors };
}
